


























































































import {Component, Prop, Vue} from 'vue-property-decorator'
import Navbar from '@/components/navbar/Navbar.vue'
import AppFooter from '@/components/footer/AppFooter.vue'
import {NeoFeed} from '@/app/NeoFeed'
import DappDetailedStats from '@/components/dappDetailed/DappDetailedStats.vue'
import DappDetailedFeed from '@/components/dappDetailed/DappDetailedFeed.vue'
import DappDetailedSummary from '@/components/dappDetailed/DappDetailedSummary.vue'
import {Dapp} from '@/model/resource/Dapp'
import {DappInfo} from '@/model/resource/DappInfo'
import {ContractCollection} from '@/model/collection/ContractCollection'
import DappDetailedTablesSection from '@/components/dappDetailed/DappDetailedTablesSection.vue'
import {TokensTableItemsCollection} from '@/model/collection/TokensTableItemsCollection'
import {NftCollectionCollection} from '@/model/collection/NftCollectionCollection'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'

@Component({
  components: {
    DappDetailedTablesSection,
    DappDetailedStats,
    DappDetailedFeed,
    DappDetailedSummary,
    Navbar,
    AppFooter,
  },
})
export default class DappDetailed extends Vue {
  @Prop({type: Boolean, required: true}) isDapp!: boolean

  tokensTableItemsCollection = new TokensTableItemsCollection()
  nftCollectionCollection = new NftCollectionCollection()
  contractCollection = new ContractCollection()
  orbitProjectCollection = new OrbitProjectCollection()

  dapp = new Dapp()
  dappInfo = new DappInfo()
  feed = new NeoFeed()

  initialHash = this.$route.params.hash ?? null

  get isOrbitEnabled(): boolean {
    return this.$auth?.global?.isOrbitFeatureActive !== false
  }

  async created() {
    await this.populateResources()
  }

  applyResources() {
    const tokenTotal = this.tokensTableItemsCollection.total
    this.tokensTableItemsCollection.perPage =
      tokenTotal != null && tokenTotal > 0 ? tokenTotal : 500
    this.tokensTableItemsCollection.orderBy = 'marketCap'
    this.tokensTableItemsCollection.minOrder = 0
    this.tokensTableItemsCollection.asc = false
    this.tokensTableItemsCollection.slugDapp = this.dapp.slug

    this.nftCollectionCollection.slugDapp = this.dapp.slug
    this.nftCollectionCollection.isVisible = true
    this.nftCollectionCollection.minOrder = 0

    if (this.dapp.blockchainVersion?.networkIdentifier) {
      this.nftCollectionCollection.networkIdentifier = this.dapp.blockchainVersion.networkIdentifier
      this.tokensTableItemsCollection.networkIdentifier = this.dapp.blockchainVersion.networkIdentifier
    }
  }

  async populateResources() {
    if (!this.$route.params.id) {
      await this.$router.push('/')
      return
    }

    try {
      this.$await.init('softQuery')

      const promises: Promise<unknown>[] = [
        this.dapp.getDapp(this.$route.params.id),
        this.dappInfo.getInfoDapp(this.$route.params.id),
      ]

      await Promise.all(promises)

      this.applyResources()

      if (this.isOrbitEnabled) {
        this.orbitProjectCollection.idDappFk = [this.dapp.idDappPk]
      } else {
        // Prevent stale orbit data when feature is disabled.
        this.orbitProjectCollection.items = []
      }

      const newPromises: Promise<unknown>[] = [
        this.tokensTableItemsCollection.queryAsPage(),
        this.nftCollectionCollection.queryAsPage(),
      ]
      if (this.isOrbitEnabled) {
        newPromises.push(this.orbitProjectCollection.queryAsPage())
      }

      await Promise.allSettled(newPromises)

      this.$await.done('softQuery')
    } catch {
      this.$await.done('softQuery')
      await this.$router.push('/')
    }

    try {
      this.feed.populate()
    } catch {
      this.feed = new NeoFeed()
    }
  }
}
